import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { setVisualTag } from "@/lib/api";
import { toast } from "sonner";

export function VisualTagField({ character, onChanged }) {
  const [value, setValue] = useState(character.visual_tag || "");
  const [saving, setSaving] = useState(false);
  const dirty = value !== (character.visual_tag || "");

  const save = async () => {
    setSaving(true);
    try {
      const updated = await setVisualTag(character.id, value.trim());
      toast.success("Physical description saved");
      onChanged(updated);
    } catch (e) {
      toast.error("Failed to save physical description");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-1">
      <label className="text-[10px] font-mono uppercase tracking-wider text-slate-500">
        Physical Description — hair, skin tone, body build, outfit (written into every generation
        prompt alongside the reference image — the image alone is NOT enough for Grok to lock identity)
      </label>
      <div className="flex gap-1.5">
        <Textarea
          data-testid={`visual-tag-input-${character.id}`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="a tall woman with a striking asymmetrical white-and-burgundy bob, tan skin, and a curvy build, wearing an off-shoulder burgundy satin dress"
          rows={2}
          className="bg-slate-950 border-slate-800 rounded-sm text-xs"
        />
        {dirty && (
          <Button data-testid={`visual-tag-save-btn-${character.id}`} onClick={save} disabled={saving} size="sm" className="h-8 bg-blue-600 hover:bg-blue-500 rounded-sm shrink-0 text-xs">
            {saving ? "…" : "Save"}
          </Button>
        )}
      </div>
    </div>
  );
}
